<form [formGroup]="formGroup">
    <div class="formWrapper">
        <lsq-input
            [formControlName]="'documentName'"
            [name]="'document-name'"
            label="Document Name*"
            [group]="formGroup"
        >
        </lsq-input>
        <lsq-textarea
            label="Document Description*"
            name="document-description"
            [resize]="true"
            [floatLabel]="false"
            [group]="formGroup"
            formControlName="documentDescription"
        >
        </lsq-textarea>
        <lsq-select
            id="file-format-select"
            [options]="fileOptions"
            [formControlName]="'fileFormat'"
            [group]="formGroup"
            label="Allowed File Format*"
            [disabled]="formGroup.value.hasDocuments"
        >
        </lsq-select>
        <dr-schedule-document-request
            *ngIf="schemaType !== 'Prospect'"
            [formGroup]="formGroup"
            [fieldSchema]="fieldSchema"
        ></dr-schedule-document-request>
        <ng-container *ngIf="isDuplicatedName$ | async">
            <div class="notification-banner">
                <lsq-icon [type]="icons.Alert" [color]="color.Yellow" [width]="20" [height]="18">
                </lsq-icon>
                <div class="notification-text">
                    A document with the name
                    <strong>{{ formGroup.value.documentName }}</strong> already exists. Submitting
                    this request will generate a duplicate name.
                </div>
            </div>
        </ng-container>
        <div class="invite-error" *ngIf="formGroup.errors?.err">
            {{ formGroup.errors?.err }}
        </div>
    </div>
</form>
